<template>
	<div class="editor">
		<editor-menu-bar :editor="editor" v-slot="{ commands, isActive }">
			<div class="menubar">
				<button
					class="menubar__button"
					:class="{ 'is-active': isActive.bold() }"
					@click="commands.bold"
					title="Bold"
				>
					<i class="fas fa-bold"></i>
				</button>

				<button
					class="menubar__button"
					:class="{ 'is-active': isActive.italic() }"
					@click="commands.italic"
					title="Italic"
				>
					<i class="fas fa-italic"></i>
				</button>

				<button
					class="menubar__button"
					:class="{ 'is-active': isActive.strike() }"
					@click="commands.strike"
					title="Strikethrough"
				>
					<i class="fas fa-strikethrough"></i>
				</button>

				<button
					class="menubar__button"
					:class="{ 'is-active': isActive.underline() }"
					@click="commands.underline"
					title="Underline"
				>
					<i class="fas fa-underline"></i>
				</button>

				<button
					class="menubar__button"
					:class="{ 'is-active': isActive.heading({ level: 1 }) }"
					@click="commands.heading({ level: 1 })"
					title="Heading 1"
				>H1</button>

				<button
					class="menubar__button"
					:class="{ 'is-active': isActive.heading({ level: 2 }) }"
					@click="commands.heading({ level: 2 })"
					title="Heading 2"
				>H2</button>

				<button
					class="menubar__button"
					:class="{ 'is-active': isActive.heading({ level: 3 }) }"
					@click="commands.heading({ level: 3 })"
					title="Heading 3"
				>H3</button>

				<button
					class="menubar__button"
					:class="{ 'is-active': isActive.bullet_list() }"
					@click="commands.bullet_list"
					title="Bullet list"
				>
					<i class="fas fa-list"></i>
				</button>

				<button
					class="menubar__button"
					:class="{ 'is-active': isActive.ordered_list() }"
					@click="commands.ordered_list"
					title="Numbered list"
				>
					<i class="fas fa-list-ol"></i>
				</button>

				<button
					class="menubar__button"
					:class="{ 'is-active': isActive.blockquote() }"
					@click="cmd(commands.blockquote)"
					title="Quote"
				>"</button>

				<button class="menubar__button" @click="commands.horizontal_rule" title="Horizontal Line">
					<i class="fas fa-ruler-horizontal"></i>
				</button>

				<button class="menubar__button" @click="commands.undo" title="Undo">
					<i class="fas fa-undo"></i>
				</button>

				<button class="menubar__button" @click="commands.redo" title="Redo">
					<i class="fas fa-redo"></i>
				</button>
			</div>
		</editor-menu-bar>
		<br>
		<editor-content class="editor__content" :editor="editor" @drop="drop($event)"/>
	</div>
</template>

<script>
	import { Editor, EditorContent, EditorMenuBar } from "tiptap";
	import { insertText } from "tiptap-commands";
	import {
		Blockquote,
		CodeBlock,
		HardBreak,
		Heading,
		HorizontalRule,
		OrderedList,
		BulletList,
		ListItem,
		TodoItem,
		TodoList,
		Bold,
		Code,
		Italic,
		Link,
		Strike,
		Underline,
		History,
		Image
	} from "tiptap-extensions";
	export default {
		name: "ArticleBodyExtract",
		props: {
			value: {}
		},
		components: {
			EditorContent,
			EditorMenuBar
		},
		data() {
			return {
				editor: new Editor({
					extensions: [
						new Blockquote(),
						new BulletList(),
						new CodeBlock(),
						new HardBreak(),
						new Heading({ levels: [1, 2, 3] }),
						new HorizontalRule(),
						new ListItem(),
						new OrderedList(),
						new TodoItem(),
						new TodoList(),
						new Link(),
						new Bold(),
						new Code(),
						new Italic(),
						new Strike(),
						new Underline(),
						new History(),
						new Image()
					],
					content: this.value.text
				})
			};
		},
		watch: {
			value: function() {
				this.editor.setContent(this.value.text);
			}
		},
		beforeDestroy() {
			this.editor.destroy();
		},
		mounted() {
			this.editor.on("update", ({ getHTML, getJSON }) => {
				this.value.text = getHTML();
				this.processImages(getJSON());
			});
			this.editor.setContent(this.value.text);
		},
		methods: {
			processImages(json) {
				json.content.forEach(element => {
					if (element.type === "image") {
						this.$emit("check-image", element);
					} else {
						if (element.content !== undefined) {
							this.processImages(element);
						}
					}
				});
			},
			cmd(command) {
				command();
			},
			doInsertImage(command) {
				// inserts image programmatically
				command({
					src:
						"https://www.google.com.au/images/branding/googlelogo/2x/googlelogo_color_92x30dp.png"
				});
				// give focus back to editor
				this.editor.focus();
			},
			doInsertText() {
				const { view } = this.editor;
				// inserts char programmatically
				insertText("some text from somwhere.")(
					view.state,
					view.dispatch,
					view
				);
				// give focus back to editor
				this.editor.focus();
			}
		}
	};
</script>
<style scoped>
.menubar__button {
	border: 1px solid grey;
	background-color: white;
	color: black;
	font-size: 16px;
	cursor: pointer;
	width: 38px;
	height: 30px;
}

.editor__content {
	border-top-width: 1px solid grey;
	max-height: 600px;
	overflow: auto;
	min-height: 50px;
	border: 1px solid grey;
}

img {
	max-width: 600px;
	max-height: 400px;
	width: 600px;
	height: 400px;
	object-fit: contain;
}
</style>
<style>
blockquote {
	background: #f9f9f9;
	border-left: 10px solid #ccc;
	margin: 1.5em 10px;
	padding: 0.5em 10px;
	quotes: "\201C""\201D""\2018""\2019";
}
blockquote:before {
	color: #ccc;
	content: open-quote;
	font-size: 4em;
	line-height: 0.1em;
	margin-right: 0.25em;
	vertical-align: -0.4em;
}
blockquote p {
	display: inline;
}
</style>